<template>
  <div class="wh">
    <div class="bg1" :style="{height:height}"></div>
    <div class="bg2" :style="{height:height}">
      <div class="flex align-center flex-direction img-100 bg-zz" :style="{height:height}">
        <div class="title">开发游戏配合雾化</div>
        <div class="subtitle">开创趣味雾化独家体验</div>

        <div class="qr-img">
          <img class="img" src="@/assets/img/xiangmu/d-1249.png" alt srcset />
          <img class="img" src="@/assets/img/xiangmu/d-1250.png" alt srcset />
        </div>
      </div>
    </div>
    <div class="bg3">
      <div class="flex align-center justify-center flex-direction img-100 bg-zz">
        <div class="title">多国安全认证 数项专利加持</div>
        <img class="img" src="@/assets/img/xiangmu/1217.png" alt srcset />
        <img class="img" src="@/assets/img/xiangmu/zhengshu.png" alt srcset />
      </div>
    </div>
    <div class="bg4">
      <div class="container-fluid">
        <div class="row">
          <div class="flex align-center justify-center flex-direction img-100 bg-zz">
            <div class="title">让孩子开心 让家长省心 让医生放心</div>
            <img class="img" src="@/assets/img/xiangmu/114.png" alt srcset />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      height: ""
    };
  },
  beforeMount() {
    const that = this;
    var w = document.documentElement.clientWidth || document.body.clientWidth;
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    if (w > 992) {
      that.height = h - 80 + "px";
    } else {
      that.height = h / 3 + "px";
    }
    window.onresize = () => {
      var w = document.documentElement.clientWidth || document.body.clientWidth;
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (w > 992) {
        that.height = h - 80 + "px";
      } else {
        that.height = h / 3 + "px";
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.bg1 {
  background-color: transparent;
  background-image: url("../../assets/img/xiangmu/bg1257@2x.jpg");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg2 {
  background-color: transparent;
  background-image: url("../../assets/img/xiangmu/bg1258@2x.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg3 {
  background: #f5f5f5;
}

.bg4 {
  background-color: transparent;
  background-image: url("../../assets/img/xiangmu/bg1260@2x.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-zz {
  position: relative;
  padding-bottom: 80px;

  .title {
    font-size: 40px;
    padding: 60px 0 20px 0;
  }
  .subtitle {
    font-size: 20px;
  }
  .img {
    width: 50%;
    margin-top: 40px;
  }

  .qr-img {
    position: absolute;
    bottom: 40px;
    left: 180px;
    display: flex;

    img {
      margin-right: 20px;
    }
  }
}

@media (max-width: 576px) {
  .bg-zz {
    position: relative;
    padding-bottom: 80px;

    .title {
      font-size: 22px;
      padding: 30px 0 10px 0;
    }
    .subtitle {
      font-size: 16px;
    }
    .img {
      width: 80%;
      margin-top: 20px;
    }

    .qr-img {
      position: absolute;
      bottom: 20px;
      left: 20px;
      display: flex;

      img {
        margin-right: 20px;
        height: 80px;
        width: 80px;
      }
    }
  }
}
</style>